/**
 * @generated SignedSource<<dd85fb6489002b6817134a06d89f761c>>
 * @relayHash c0ea24163e6b29e5fc2b57f1528c3ee1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0689b9326375ef8e3997b0119098779ab5ab30fec4d899d01315b7ac21d29ec6

import type { ConcreteRequest, Query } from 'relay-runtime';
export type chatSimulator_agentIdentityQuery$variables = {
  helpCenterAri: string;
};
export type chatSimulator_agentIdentityQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri: {
    readonly agent?: {
      readonly id?: string;
      readonly name?: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type chatSimulator_agentIdentityQuery = {
  response: chatSimulator_agentIdentityQuery$data;
  variables: chatSimulator_agentIdentityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "name": "name"
    }
  ],
  "type": "CsmAiAgent"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "chatSimulator_agentIdentityQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ]
              }
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "chatSimulator_agentIdentityQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v3/*: any*/)
                ]
              },
              (v2/*: any*/)
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0689b9326375ef8e3997b0119098779ab5ab30fec4d899d01315b7ac21d29ec6",
    "metadata": {},
    "name": "chatSimulator_agentIdentityQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6992c53ab6a75e34119307e572c302f2";

export default node;
